export default __webpack_public_path__ + "static/media/trading-alerts-tradingAlerts-light.f0b47800.png";